import React from "react";
import { observer, inject } from "mobx-react";
import Swipe from "react-easy-swipe";
import withStyles from "react-jss";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";
import { TARIFF_BY_ID } from "Services/queries";
import { CompareTable } from "ComponentsUI/Compare";
import { EmptyStubWrapper } from "ComponentsUI/EmptyStub";
import { PaddingBottom } from "ComponentsUI/Spacings";
import { Col } from "ComponentsUI/Styles/Grid";
import Button from "ComponentsUI/Button";
import base from "Styles/themes/base";
import {
	StyledRow,
	ProvidersRow,
	SpeedRow,
	ChannelsRow,
	DodyRow,
	SaleRow,
	CostRow,
	CostMBRow,
	SupportRow,
	ConnectTimeRow,
	ConnectCostRow,
	TrapRow,
	ButtonsRow,
	MobilePackageInternetRow,
	MobileCallsRow,
	MobileSMSRow,
} from "../Rows";

const styles = (theme) => {
	return {
		root: {},
	};
};

@inject("ApplicationModel")
@observer
class CompareLayout extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			initComponent: false,
			moveValue: 0,
		};
	}

	translate = 0;
	tempTranslate = 0;
	canMove = false;
	classes = {};

	componentDidMount() {
		if (!this.state.initComponent) this.initComponent();
	}

	initComponent() {
		let compareTarifficationModel = this.props.ApplicationModel.compareTarifficationsModel;
		compareTarifficationModel.setCurrentSlide(0);
		compareTarifficationModel.setNextSlideFunction(() => this.nextSlide());
		compareTarifficationModel.setPreviousSlideFunction(() => this.previusSlide());

		if (window.outerWidth > base.breakpoints.lg) {
			this.setState({
				initComponent: true,
				shift: 200,
			});
			compareTarifficationModel.setMaxAmountCols(6);
			return;
		}
		if (window.outerWidth > base.breakpoints.md) {
			this.setState({
				initComponent: true,
				shift: 160,
			});
			compareTarifficationModel.setMaxAmountCols(6);
			return;
		}

		if (window.outerWidth > base.breakpoints.sm) {
			this.setState({
				initComponent: true,
				shift: 180,
			});
			compareTarifficationModel.setMaxAmountCols(4);
			return;
		}

		this.setState({
			initComponent: true,
			shift: (this.root.offsetWidth - 40) * 0.375,
		});
		compareTarifficationModel.setMaxAmountCols(3);
	}

	removeTariff(index) {
		let array = this.props.compareTariffs.slice();
		let selectedTariff = array.splice(index, 1);
		this.props.removeTariff(selectedTariff[0]);
	}

	previusSlide() {
		let compareTarifficationModel = this.props.ApplicationModel.compareTarifficationsModel;
		let currentSlide = compareTarifficationModel.currentSlide;

		this.moveTable((currentSlide - 1) * this.state.shift);
		this.translate = (currentSlide - 1) * this.state.shift;

		compareTarifficationModel.setCurrentSlide(currentSlide - 1);
	}

	moveTable(value) {
		this.setState({
			moveValue: value,
		});
	}

	nextSlide() {
		let compareTarifficationModel = this.props.ApplicationModel.compareTarifficationsModel;
		let currentSlide = compareTarifficationModel.currentSlide;
		compareTarifficationModel.setCurrentSlide(currentSlide + 1);
		this.translate = (currentSlide + 1) * this.state.shift;

		this.moveTable((currentSlide + 1) * this.state.shift);
	}

	onSwipeMove(pos, event) {
		if (!this.canMove && Math.abs(pos.x) < 75) {
			return;
		}
		this.canMove = true;

		if (this.translate - pos.x <= 0) {
			this.moveTable(0);
			this.tempTranslate = 0;
			return;
		}

		let widthTable = this.table.offsetWidth;
		let wrapperWidth = this.props.compareTariffs.length * this.state.shift;
		let differ = wrapperWidth - widthTable - 40;
		if (differ < 0) return;
		if (this.translate - pos.x >= differ) {
			this.moveTable(differ);
			this.tempTranslate = differ;
			return;
		}
		this.moveTable(this.translate - pos.x);
		this.tempTranslate = this.translate - pos.x;
	}

	onSwipeEnd() {
		this.translate = this.tempTranslate;
		this.canMove = false;
	}

	closeModal() {
		let modalModel = this.props.ApplicationModel.modalModel;
		if (modalModel.isOpen) {
			modalModel.toggleModal();
		}
	}

	onClickAddHandlerTv(tariffId) {
		this.closeModal();
		let modalModel = this.props.ApplicationModel.modalModel;
		let promise1 = import("Layouts/modalLayout");
		let promise2 = import("Containers/ChannelsContainer");
		let apolloTariffQueryPromise = this.props.ApplicationModel.apolloTransportLayer.query({
			query: TARIFF_BY_ID,
			variables: {
				id: tariffId,
			},
		});
		Promise.all([promise1, promise2, apolloTariffQueryPromise]).then((modules) => {
			let ModalLayout = modules[0].default;
			let ChannelsContainer = modules[1].default;
			let tariff = modules[2].data.tariffsOne;

			if (!!tariff.tv.use_text) {
				return;
			}
			modalModel.toggleModal(
				<ModalLayout closeModal={() => this.closeModal()}>
					<ChannelsContainer tariff={tariff} />
				</ModalLayout>
			);
		});
	}

	render() {
		let classes = this.props.classes;
		let text = this.props.ApplicationModel.text;
		let buttonComponent = (
			<Button typeText={"small"} size={"low"} status={"withoutAccent"}>
				<span
					className="icon48 icon-playlist-add"
					style={{
						fontSize: "24px",
						color: "#d3cee1",
					}}
				/>
				{text.compare}
			</Button>
		);

		return (
			<div className={classes.root} ref={(root) => (this.root = root)}>
				{this.props.compareTariffs.length > 1 && (
					<Swipe
						onSwipeMove={(pos, event) => this.onSwipeMove(pos, event)}
						onSwipeEnd={() => this.onSwipeEnd()}
						tolerance={75}
					>
						<Container>
							<Row>
								<Col xs="12">
									<div ref={(table) => (this.table = table)}>
										<PaddingBottom>
											<CompareTable
												data={this.props.compareTariffs}
												moveValue={this.state.moveValue}
											>
												<StyledRow>
													<ProvidersRow />
												</StyledRow>
												<StyledRow>
													<SpeedRow
														text={text}
														header={text.comparisonSpeed}
														maxSpeedTariff={this.props.maxSpeedTariff}
													/>
												</StyledRow>
												<StyledRow>
													<ChannelsRow
														onClickHandler={(id) => this.onClickAddHandlerTv(id)}
														header={text.comparisonСhannelsNumber}
														maxChannelsTvTariff={this.props.maxChannelsTvTariff}
													/>
												</StyledRow>
												<StyledRow>
													<MobilePackageInternetRow
														text={text}
														header={text.ROW_MOBILE_PACKAGE}
														high={this.props.betterMobileInternetPackage}
													/>
												</StyledRow>
												<StyledRow>
													<MobileCallsRow
														text={text}
														header={text.ROW_MOBILE_MINUTES}
														high={this.props.betterMobileCallPackage}
													/>
												</StyledRow>
												<StyledRow>
													<MobileSMSRow
														text={text}
														header={text.ROW_MOBILE_SMS}
														high={this.props.betterMobileSmsPackage}
													/>
												</StyledRow>
												<StyledRow>
													<DodyRow
														header={text.comparisonAdditionalServices}
														windowSizeModel={this.props.windowSizeModel}
														text={text}
													/>
												</StyledRow>
												<StyledRow>
													<SaleRow text={text} header={text.comparisonSale} />
												</StyledRow>
												<StyledRow>
													<CostRow
														text={text}
														header={text.comparisonSubscriptionFee}
														minCostTariff={this.props.minCostTariff}
													/>
												</StyledRow>
												<StyledRow>
													<CostMBRow
														text={text}
														header={text.comparisonMbFee}
														minSingleMBOTariff={this.props.minSingleMBOTariff}
													/>
												</StyledRow>
												<StyledRow>
													<SupportRow text={text} header={text.comparisonTechnicalSupport} />
												</StyledRow>
												<StyledRow>
													<ConnectTimeRow
														text={text}
														header={text.comparisonTermConnect}
														minConnectionTimeTariff={this.props.minConnectionTimeTariff}
													/>
												</StyledRow>
												<StyledRow>
													<ConnectCostRow text={text} header={text.comparisonCostConnect} />
												</StyledRow>
												{/* <StyledRow>
                                                    <TrapRow
                                                        header={text.comparisonTrap}
                                                    />
                                                </StyledRow> */}
												<StyledRow>
													<ButtonsRow
														removeCallback={(index) => this.removeTariff(index)}
														comparisonDelete={text.comparisonDelete}
														comparisonConnect={text.comparisonConnect}
														onChangeUrl={this.props.onChangeUrl}
													/>
												</StyledRow>
											</CompareTable>
										</PaddingBottom>
									</div>
								</Col>
							</Row>
						</Container>
					</Swipe>
				)}
				{this.props.compareTariffs.length <= 1 && (
					<EmptyStubWrapper
						headerText={this.props.firstSuggestion}
						displayText={this.props.secondSuggestion}
						iconHeader={"icon-balance"}
						buttonComponent={buttonComponent}
					/>
				)}
			</div>
		);
	}
}

export default withStyles(styles)(CompareLayout);
